import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
const CALLBACK_NAME = 'vueRecaptchaApiLoaded';
const SCRIPT_ID = '__RECAPTCHA_SCRIPT';
let loaded = false;
let waiting = [];
function notifyLoaded() {
  loaded = true;
  waiting.forEach(resolve => resolve(window.grecaptcha));
  waiting = [];
}
if (typeof window !== 'undefined') {
  window[CALLBACK_NAME] = notifyLoaded;
}
function loadRecaptcha(host, language) {
  if (typeof window !== 'undefined' && window.grecaptcha && window.grecaptcha.render) {
    notifyLoaded();
  }
  if (loaded) {
    return Promise.resolve(window.grecaptcha);
  }
  const pending = new Promise(resolve => waiting.push(resolve));
  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = `https://${host}/recaptcha/api.js?onload=${CALLBACK_NAME}&render=explicit&hl=${language || ''}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
  return pending;
}
export default {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: String,
    badge: String,
    type: String,
    size: String,
    tabindex: String,
    recaptchaHost: {
      type: String,
      default: 'www.google.com'
    },
    language: {
      type: String,
      default: ''
    }
  },
  emits: ['verify', 'expired', 'error', 'render'],
  data() {
    return {
      widgetId: null
    };
  },
  mounted() {
    loadRecaptcha(this.recaptchaHost, this.language).then(grecaptcha => {
      if (!this.$refs.container || this.widgetId !== null) {
        return;
      }
      const element = this.$refs.container.children[0] || this.$refs.container;
      this.widgetId = grecaptcha.render(element, {
        sitekey: this.sitekey,
        theme: this.theme,
        badge: this.badge,
        type: this.type,
        size: this.size,
        tabindex: this.tabindex,
        callback: response => this.$emit('verify', response),
        'expired-callback': () => this.$emit('expired'),
        'error-callback': () => this.$emit('error')
      });
      this.$emit('render', this.widgetId);
    });
  },
  methods: {
    reset() {
      if (window.grecaptcha && this.widgetId !== null) {
        window.grecaptcha.reset(this.widgetId);
      }
    },
    execute() {
      if (window.grecaptcha && this.widgetId !== null) {
        window.grecaptcha.execute(this.widgetId);
      }
    }
  }
};